/* eslint-disable no-console */
import { useCallback } from 'react'

import { useToast } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import { miniProgramConnector } from '@pancakeswap/wagmi/connectors/miniProgram'
import { useConnect } from 'wagmi'
import getWeb3Provider from 'utils/mpBridge'

const connectorFactory = miniProgramConnector({ getWeb3Provider })

export const getAccount = async (): Promise<string | undefined> => {
  try {
    const provider = getWeb3Provider()
    if (!provider) return undefined
    const accounts = (await provider.request({ method: 'eth_accounts' })) as string[]
    return accounts[0]
  } catch {
    return undefined
  }
}

const useActive = () => {
  const { connectAsync, connectors } = useConnect()
  return useCallback(
    () => {
      const connector = connectors.find((c) => c.id === 'miniprogram') ?? connectorFactory
      return connectAsync({ connector }).catch((error) => {
        console.log('🚀 ~ file: useEagerConnect.ts ~ line 183 ~ activate ~ error', error)
      })
    },
    [connectAsync, connectors],
  )
}
export const useEagerConnect = () => {
  // noop
}

export const useActiveHandle = () => {
  const handleActive = useActive()
  const { toastSuccess } = useToast()
  const { t } = useTranslation()

  const main = async () => {
    console.log('~ before getAccount')
    const address = await getAccount()
    console.log('~ after getAccount', address)
    return new Promise((resolve) => {
      handleActive().then(resolve)
    })
  }
  return async (showToast = true) => {
    await main()
    const address = await getAccount()
    if (address && showToast) {
      toastSuccess(t('Success'), 'Wallet connected')
    }
  }
}
export default useEagerConnect
